<template>
  <pre>
    <code ref="codeBlock" :class="languageClass">{{ code }}</code>
  </pre>
</template>

<script>
import Prism from "prismjs";
import "prismjs/themes/prism.css"; // Optional: Prism Theme

export default {
  name: "CodeBlock",
  props: {
    code: {
      type: String,
      required: true
    },
    language: {
      type: String,
      required: true
    }
  },
  computed: {
    languageClass() {
      return `language-${this.language}`;
    }
  },
  mounted() {
    this.$nextTick(() => {
      const codeBlock = this.$refs.codeBlock;
      if (codeBlock) {
        Prism.highlightElement(codeBlock);
      }
    });
  }
};
</script>

<style scoped lang="scss">
pre,
code,
.token {
  background: transparent;
  box-shadow: none;
  padding: 0;
  margin: 0;
  font-family: "Fira Code", monospace;
  font-weight: 400;
  font-size: 16px;
}
.v-application code:before {
  content: none;
  letter-spacing: unset;
}
</style>
